import { makeStyles } from "@mui/styles";
import { Services1, SupportImage, TrainingImage } from "../../images";

export const useStyles = makeStyles((theme) => ({
	servicesGridContainer: {
		paddingTop: "6.25rem",
		[theme.breakpoints.down("sm")]: {
			paddingTop: "3rem",
		},
	},
	servicesHeader: {
		marginBottom: "6.25rem",
		[theme.breakpoints.down("sm")]: {
			marginBottom: "3rem",
		},
	},
	gridGrid: {
		width: "11.813rem",
		height: "2.5px",
		marginTop: "2.125rem",
		marginBottom: "2.125rem",
	},
	gridBorder: {
		background: "#00CC8F",
		width: "11.813rem",
		height: "2.5px",
	},
	servicesText: {
		fontSize: "3rem !important",
		fontWeight: 700,
		lineHeight: "3.75rem !important",
		fontFamily: "OutfitRegular",
		color: "#222222",
		[theme.breakpoints.down("sm")]: {
			fontSize: "2.5rem !important",
			fontWeight: 700,
			lineHeight: "3rem !important",
		},
	},
	servicesGroup: {
		padding: "6rem 0",
		[theme.breakpoints.down("sm")]: {
			padding: "0",
		},
	},
	servicesContainer: {
		marginBottom: "6.25rem",
		[theme.breakpoints.down("sm")]: {
			marginBottom: "3rem",
		},
	},
	servicesImage1: {
		backgroundImage: `url(${Services1})`,
		backgroundRepeat: "no-repeat",
		objectFit: "fill",
		backgroundSize: "contain",
		backgroundPosition: "center",
		[theme.breakpoints.down("sm")]: {
			paddingTop: "10rem",
			paddingBottom: "10rem",
		},
	},
	professionalText: {
		fontSize: "2.125rem !important",
		fontWeight: 600,
		lineHeight: "2.688rem !important",
		fontFamily: "OutfitRegular",
		color: "#0B3192",
		[theme.breakpoints.down("sm")]: {
			fontSize: "2rem !important",
			lineHeight: "2rem !important",
		},
	},
	professionalMetaText: {
		fontSize: "1.5rem !important",
		fontWeight: 400,
		lineHeight: "2.5rem !important",
		fontFamily: "OutfitRegular",
		color: "#555555",
		[theme.breakpoints.down("sm")]: {
			fontSize: "1.2rem !important",
			lineHeight: "2rem !important",
		},
	},
	gridBorderProGrid: {
		width: "6.25rem",
		height: "2px",
		marginTop: "0.875rem",
		marginBottom: "0.875rem",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
		},
	},
	gridBorderPro: {
		background: "#00CC8F",
		width: "6.25rem",
		height: "2px",
		[theme.breakpoints.down("sm")]: {
			width: "90%",
		},
	},
	supportText: {
		fontSize: "2.125rem !important",
		fontWeight: 600,
		lineHeight: "2.688rem !important",
		fontFamily: "OutfitRegular",
		color: "#0B3192",
	},
	supportMetaText: {
		fontSize: "1.5rem !important",
		fontWeight: 400,
		lineHeight: "2.5rem !important",
		fontFamily: "OutfitRegular",
		color: "#555555",
	},
	supportImage: {
		backgroundImage: `url(${SupportImage})`,
		//backgroundSize: "cover",
		backgroundRepeat: "no-repeat",
		objectFit: "fill",
		backgroundSize: "contain",
		backgroundPosition: "center",
		//paddingTop: "10rem",
		//paddingBottom: "10rem",
	},
	trainingImage: {
		backgroundImage: `url(${TrainingImage})`,
		//backgroundSize: "cover",
		backgroundRepeat: "no-repeat",
		objectFit: "fill",
		backgroundSize: "contain",
		backgroundPosition: "center",
		//paddingTop: "10rem",
		//paddingBottom: "10rem",
	},
}));
